import React, { Component } from 'react';
import _ from 'lodash';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { ChevronRight, NavigateBeforeSharp } from '@material-ui/icons';
import {
    WithStyles,
    createStyles,
    Menu,
    MenuItem,
    Typography
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { MyPATIconButton, MyPATLink } from './../common';
import MenuData from './MenuData';
import CustomInfoIcon from './CustomInfoIcon';


const styles = (theme: Theme) => createStyles({
    root: {
        display: 'inline-block'
    },
    mainIcon: {
        color: theme.palette.grey[400],
    },
    menu: {
        transform: 'translateY(10px) scale(1, 1) translateZ(0px) translateX(-15px) !important',
        overflow: 'unset'
    },
    menuArrow: {
        content: '',
        position: 'absolute',
        top: '-14px',
        right: 2,
        border: '7px solid transparent',
        borderBottomColor: theme.palette.common.white,
        display: 'block',
        outline: 0
    },
    menuArrow1: {
        content: '',
        position: 'absolute',
        top: '-13px',
        right: '8.25rem',
        border: '7px solid transparent',
        borderBottomColor: theme.palette.common.white,
        display: 'block',
        outline: 0
    },
    menuArrow2: {
        content: '',
        position: 'absolute',
        top: '-13px',
        right: '2.32rem',
        border: '7px solid transparent',
        borderBottomColor: theme.palette.common.white,
        display: 'block',
        outline: 0
    },
    menuArrow3: {
        content: '',
        position: 'absolute',
        top: '-13px',
        right: '2.93rem',
        border: '7px solid transparent',
        borderBottomColor: theme.palette.common.white,
        display: 'block',
        outline: 0
    },
    menuArrow4: {
        content: '',
        position: 'absolute',
        top: '-13px',
        right: '3.18rem',
        border: '7px solid transparent',
        borderBottomColor: theme.palette.common.white,
        display: 'block',
        outline: 0
    },
    redIndicator: {
        position: 'absolute',
        right: 0,
        top: -12,
        color: 'rgb(242 60 60)',
        '&>svg':{
            height: 14,
            width: 14
        }
    },
    menuItem: {
        borderStyle: 'solid',
        borderBottomWidth: 1,
        borderColor: theme.palette.grey[300],
        padding: 0,
        height: 'auto',
        minWidth: '170px',
        '&:last-child': {
            borderBottomWidth: 0,
        },
        '& a': {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            paddingRight: theme.spacing.unit * 2,
            paddingLeft: theme.spacing.unit * 2,
            width: '100%'
        },
        '& img, & p': {
            display: 'inline-block',
            verticalAlign: 'middle',
            fontSize: 14,
            lineHeight: '19px',
            color: '#333333'
        }
    },
    menuIcon: {
        marginRight: theme.spacing.unit,
        height: 22,
        width: 20,
        color: '#1D7DEA',
        fill: '#1D7DEA'
    },
    marginLeft5: {
        marginLeft: theme.spacing.unit
    },
    toolTipArrow: {
        '&:hover:after': {
            content: '""',
            position: 'absolute',
            left: '50%',
            marginLeft: -6,
            bottom: -8,
            width: 0,
            height: 0,
            borderLeft: '5px solid rgba(0, 0, 0, 0)',
            borderRight: '5px solid rgba(0, 0, 0, 0)',
            borderBottom: '8px solid rgb(0, 0, 0)'
        }
    },
    tooltipDetails: {
        position: 'absolute',
        marginTop: 42,
        zIndex: 999999
    }
});


//@ts-ignore
interface MyPATPopMenuProps extends WithStyles<typeof styles> {
    classes: any,
    icon: React.ComponentType<SvgIconProps>,
    id: string,
    menuItem: MenuData[],
    clicked?: Function,
    tooltipValue: string,
    shareButtonDisabled: boolean,
    showIndicator: boolean
}

interface MyPATPopMenuState {
    anchorEl: any,
    showTooltip: boolean
}

class MyPATPopMenu extends Component<MyPATPopMenuProps, MyPATPopMenuState>{
    constructor(props: MyPATPopMenuProps, state: MyPATPopMenuState) {
        super(props);

        this.state = {
            anchorEl: null,
            showTooltip: false
        };

        this.openHandler = this.openHandler.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
    }

    openHandler = (event: any) => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };

    closeHandler = (event: any) => {
        this.setState({
            anchorEl: null
        });
    };

    clickedOnMenuItem(e: any, item: MenuData) {
        if (item.type == 'callback') {
            e.preventDefault();
        }

        if (this.props.clicked && item.type == 'callback') {
            this.props.clicked(item);
            e.preventDefault();
        }

    }

    buildMenuItems() {
        const { classes, shareButtonDisabled } = this.props;
        return this.props.menuItem.map((item, index) => (
            item.isDisabled ? <></> :
            <MenuItem key={index} classes={{ root: this.props.classes.menuItem }}>
                <MyPATLink style={{ opacity: item.id == 1 && shareButtonDisabled ? 0.5 : 1 }} to={item.to} displayProp="inline-block" onClick={(e: any) => { this.clickedOnMenuItem(e, item) }}>
                    {
                        item.img != ""
                            ?
                            <img src={item.img} alt="share option icon" className={this.props.classes.menuIcon} />
                            :
                            <></>
                    }
                    <Typography variant="body1">{item.text}{item.text == "Sorting Options" ? <ChevronRight className={classes.marginLeft5} /> : ""}</Typography>
                </MyPATLink>
            </MenuItem>
        )
        )
    }

    handleHover() {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }

    render() {
        const { classes, icon, id, tooltipValue, showIndicator } = this.props;
        const { anchorEl, showTooltip } = this.state;
        const Icon = icon;
        let currentURL1: any = window.location.href.split('/');
        let currentURL: any = window.location.href.split('/');
        currentURL = currentURL.includes("course");
        currentURL1 = currentURL1.includes("milestoneDetail");
        return (
            <div className={classes.root}>
                <MyPATIconButton
                    onClick={this.openHandler.bind(this)}
                    buttonVariant="flat"
                    onMouseOver={this.handleHover.bind(this)}
                    onMouseOut={this.handleHover.bind(this)}
                    className={classes.toolTipArrow}
                >
                    <MoreVertIcon
                        classes={{ root: classes.mainIcon }}
                    />
                    {
                        showIndicator && 
                        <span className={classes.redIndicator}>
                        <FiberManualRecordIcon />
                        </span>
                    }
                   
                </MyPATIconButton>
                <span className={classes.tooltipDetails}>
                    {
                        showTooltip &&
                        <>
                            <CustomInfoIcon
                                isInfoIcon={false}
                                isCenterArrow={false}
                                isRightArrow={showTooltip}
                                details={tooltipValue}
                                toolTipDirection="right" />
                        </>
                    }

                </span>

                <Menu
                    id={id}
                    classes={{ paper: classes.menu }}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.closeHandler.bind(this)}
                    onMouseLeave={this.closeHandler.bind(this)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    getContentAnchorEl={null}
                >
                    {currentURL1 == true && currentURL == true ? <div>{this.props.menuItem.map((item) => {
                        if (item.text === "Course Filter" && id === "settings-menu") {
                            return <div className={classes.menuArrow4} />
                        }
                        else {
                            return null;
                        }
                    })
                    } </div> : currentURL == true ? <div>{this.props.menuItem.map((item) => {
                        if (item.text === "Goal Management" && id === "settings-menu") {
                            return <div className={classes.menuArrow} />
                        } else if (item.text === "Sorting Options" && id === "settings-menu") {
                            return <div className={classes.menuArrow1} />
                        }
                        else if (item.text === "Copy Course" && id === "content-more-menu") {
                            return <div className={classes.menuArrow2} />
                        }
                        else if (item.text === "Edit" && id === "content-more-menu") {
                            return <div className={classes.menuArrow3} />
                        }
                        else {
                            return null;
                        }
                    })
                    }</div> : <div className={classes.menuArrow} />}
                    {this.buildMenuItems()}
                </Menu>
            </div>
        );
    }
}
// @ts-ignore
export default withStyles(styles)(MyPATPopMenu);